import { getTeamLogo } from "../getTeamLogo";

const LOGO_DIRS = {
  premier_league: "england__premier_league",
  laliga: "spain__laliga",
  bundesliga: "germany__bundesliga",
  serie_a: "italy__serie_a",
};

/** Bundled crest for a team in a domestic league, or the API crest for World Cup; null otherwise. */
export function teamLogo(name, competition, crestUrl) {
  if (competition === "world_cup") return crestUrl || null;
  const dir = LOGO_DIRS[competition];
  if (!dir) return null;
  return getTeamLogo(name, dir) || null;
}
